import type { useWidgetNotices } from "./use-widget-notices";
import s from "../cogent.module.css";
import type { useWidgetNavigation } from "../use-widget-navigation";
type Navigation = ReturnType<typeof useWidgetNavigation>;
export function WidgetNotices({
  name,
  navigation,
  notices,
}: {
  name: string;
  navigation: Navigation;
  notices: ReturnType<typeof useWidgetNotices>;
}) {
  if (navigation.open) return null;

  if (notices.remark)
    return (
      <NoteBubble
        name={name}
        kind="remark"
        text={notices.remark.text}
        hold={notices.holdRemark}
        dismiss={notices.dismissRemark}
        open={() => navigation.setOpen(true)}
      />
    );

  return null;
}

function NoteBubble({
  name,
  kind,
  text,
  noteKey,
  hold,
  dismiss,
  open,
}: {
  name: string;
  kind: "note" | "remark";
  text: string;
  noteKey?: string;
  hold: (hold: boolean) => void;
  dismiss: () => void;
  open: () => void;
}) {
  return (
    <output
      className={`${s.bubble} ${s.pageNote}`}
      aria-label={`${name}'s ${kind}`}
      data-testid={`cogent-${kind}`}
      data-key={noteKey}
      onPointerEnter={() => hold(true)}
      onPointerLeave={() => hold(false)}
    >
      <span className={s.tail} aria-hidden="true" />
      <span className={s.pageNoteBody}>
        <button
          type="button"
          className={s.pageNoteText}
          title={
            kind === "note" ? `Talk to ${name} about it` : `Talk to ${name}`
          }
          onClick={open}
        >
          {kind === "note" ? (
            <span className={s.noteLabel}>{name}&rsquo;s note</span>
          ) : null}
          {text}
        </button>
        <button
          type="button"
          className={s.icon}
          aria-label="Dismiss"
          title="Dismiss"
          onClick={dismiss}
          data-testid={`cogent-${kind}-dismiss`}
        >
          <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
            <path
              d="M4 4l8 8M12 4l-8 8"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </span>
    </output>
  );
}
